<template>
  <!-- <div class="topBox" :class="{addStyle: namePath=='home' }" :style="{width: width + 'px'}"> -->
  <div class="topBox" :class="{ addStyle: active * 1 == 0 && bgHeight < 100 }">
    <div class="logoBox">
      <div class="imgBox">
        <el-image :src="logo"></el-image>
      </div>
      <div class="name">淏睿科技</div>
    </div>

    <div class="navBox">
      <div class="navItem" :class="{ addBor: active * 1 == 0 }" @click="jumppage(0)"> 首页 </div>
      <div class="navItem" :class="{ addBor: active * 1 == 3 }" @click="jumppage(3)"> 行业咨询 </div>
      <div class="navItem" :class="{ addBor: active * 1 == 1 }" @click="jumppage(1)"> 关于我们 </div>
      <div class="navItem" :class="{ addBor: active * 1 == 2 }" @click="jumpMe"> 联系我们 </div>
      <div class="navItem" :class="{ addBor: active * 1 == 4 }" @click="jumppage(4)"> 注册 </div>
      <div class="navItem" :class="{ addBor: active * 1 == 5 }" @click="jumppage(5)"> 登录 </div>
    </div>
  </div>
</template>

<script>
var VueScrollTo = require("vue-scrollto");
export default {
  name: "headers",
  data() {
    return {
      logo: require("./images/logo.png"),
      active: "",
      bgHeight: 0,
      // width:''
    };
  },
  mounted() {
    // let path = this.$route.path
    const { path, name } = this.$route
    this.active = name == 'about' ? 1 : 0
    this.width = document.documentElement.clientWidth
    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    jumppage(val) {
      console.log('跳转')
      this.active = val
      this.$bus.$emit('setSTop', val)
      switch (val) {
        case 0:
          // this.$router.push("/home");
          this.$router.push({ path: '/home', query: { id: val } });
          break;
        case 1:
          // this.$router.push("/about");
          this.$router.push({ path: '/about', query: { id: val } });
          break;
        case 3:
          // this.$router.push("/about");
          this.$router.push({ path: '/guidance', query: { id: val } });
          break;
        case 4:
          this.$router.push({ path: '/register', query: { id: val } });
          break;
        case 5:
          this.$router.push({ path: '/login', query: { id: val } });
          break;
        default:
          break;
      }
    },

    jumpMe() {
      this.active = 2
      // this.$router.push("/about");
      this.$bus.$emit('setSTop', '2')
      this.$router.push({ path: '/about', query: { id: 2 } });
    },

    // 回到顶部
    topClick() {
      VueScrollTo.scrollTo({ offset: -100 });
    },

    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.bgHeight = scrollTop
    },

    usMe(id) {
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      })
    }
  },
};
</script>

<style lang="less" scoped>
.topBox {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100px;
  font-size: 22px;
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 999;

  .logoBox {
    display: flex;
    align-items: center;
    margin-left: 150px;

    .imgBox {
      width: 62px;
      height: 62px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
    }
  }


  .navBox {
    display: flex;
    margin-left: auto;
    margin-right: 150px;

    .navItem {
      margin-left: 80px;
      cursor: pointer;
      // background: #f00;
      padding: 10px 0;
      border-bottom: 2px solid transparent;
    }

    // .navItem:hover {
    //   border-bottom: 2px solid #3F66FF;
    // }

    .addBor {
      border-bottom: 2px solid #3F66FF;
    }
  }

}

.addStyle {
  background: transparent;
  width: 100%;
  position: fixed;
  top: 0;
}
</style>